import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceReportCreate from './InsuranceReportCreate';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	patientId: string;
	onCreate: () => void;
	attachToDiscourse?: boolean;
}

const InsuranceReportCreateModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.insuranceReportCreate.title'
			size={Size.MD}
			{...props}>
			<InsuranceReportCreate
				patientId={props.patientId}
				onCreate={props.onCreate}
				attachToDiscourse={props.attachToDiscourse}
			/>
		</BaseModal>
	);
};

export default InsuranceReportCreateModal;
